/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_ActionInputs */

const cs_pwa_install_action = /** @type {(inputs: Pwa_Install_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nainstalovat`)
};

const en_pwa_install_action = /** @type {(inputs: Pwa_Install_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install`)
};

/**
* | output |
* | --- |
* | "Install" |
*
* @param {Pwa_Install_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_action = /** @type {((inputs?: Pwa_Install_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_action(inputs)
	return cs_pwa_install_action(inputs)
});